module.exports = __webpack_public_path__ + "img/cover.6a7fef72.webp";